module.exports = __webpack_public_path__ + "assets/img/faspay_800.d390802e.png";